(() => {
  const moneyPercent = (compare, price) => compare > price ? Math.round(((compare - price) / compare) * 100) : 0;

  document.querySelectorAll('.l4m-pdp-hero').forEach((root) => {
    const form = root.querySelector('.l4m-pdp-form');
    const dataNode = root.querySelector('[data-l4m-variants]');
    if (!form || !dataNode) return;

    let variants = [];
    try { variants = JSON.parse(dataNode.textContent); } catch (_) { return; }

    const variantInput = form.querySelector('[data-l4m-variant-id]');
    const price = root.querySelector('[data-l4m-price]');
    const compare = root.querySelector('[data-l4m-compare]');
    const save = root.querySelector('[data-l4m-save]');
    const add = form.querySelector('[data-l4m-add]');
    const addLabel = form.querySelector('[data-l4m-add-label]');
    const addPrice = form.querySelector('[data-l4m-add-price]');
    const sticky = root.querySelector('[data-l4m-sticky-atc]');
    const stickyPrice = root.querySelector('[data-l4m-sticky-price]');
    const stickyVariant = root.querySelector('[data-l4m-sticky-variant]');
    const stickySubmit = root.querySelector('[data-l4m-sticky-submit]');
    const availableLabel = addLabel?.textContent?.trim() || 'Add to bag';
    const soldLabel = add?.disabled ? (addLabel?.textContent?.trim() || 'Sold out') : (root.dataset.soldLabel || 'Sold out');

    const getSelections = () => [...form.querySelectorAll('[data-option-position]')]
      .sort((a,b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map(fieldset => fieldset.querySelector('input[type="radio"]:checked')?.value || '');

    const updateCurrentLabels = () => {
      form.querySelectorAll('[data-option-position]').forEach(fieldset => {
        const selected = fieldset.querySelector('input[type="radio"]:checked');
        const current = fieldset.querySelector('[data-option-current]');
        if (selected && current) current.textContent = selected.dataset.displayLabel || selected.value;
      });
    };

    const updateVariant = () => {
      const selected = getSelections();
      const variant = variants.find(v => v.options.length === selected.length && v.options.every((value, index) => value === selected[index]));
      if (!variant) return;

      variantInput.value = variant.id;
      if (price) price.textContent = variant.price_formatted || '';
      if (compare) {
        compare.textContent = variant.compare_formatted || '';
        compare.classList.toggle('is-hidden', !(variant.compare_at_price > variant.price));
      }
      if (save) {
        const pct = moneyPercent(variant.compare_at_price, variant.price);
        const template = save.dataset.saveTemplate || 'Save [percent]%';
        save.textContent = pct ? template.replace('[percent]', pct) : '';
        save.classList.toggle('is-hidden', !pct);
      }
      if (add) add.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? availableLabel : soldLabel;
      if (addPrice) addPrice.textContent = variant.available ? ` — ${variant.price_formatted || ''}` : '';
      if (stickyPrice) stickyPrice.textContent = variant.price_formatted || '';
      if (stickyVariant) stickyVariant.textContent = variant.title === 'Default Title' ? '' : (variant.title || '');
      if (stickySubmit) stickySubmit.disabled = !variant.available;
      updateCurrentLabels();

      root.dispatchEvent(new CustomEvent('l4m:variant-change', { bubbles: true, detail: { variant } }));
    };

    form.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) updateVariant();
    });

    const qty = form.querySelector('[data-l4m-qty-input]');
    form.querySelector('[data-l4m-qty-minus]')?.addEventListener('click', () => {
      qty.value = Math.max(Number(qty.min) || 1, Number(qty.value || 1) - 1);
    });
    form.querySelector('[data-l4m-qty-plus]')?.addEventListener('click', () => {
      qty.value = Number(qty.value || 1) + 1;
    });

    stickySubmit?.addEventListener('click', () => {
      if (!stickySubmit.disabled) form.requestSubmit();
    });

    const primaryBuyRow = form.querySelector('.l4m-pdp-buyrow');
    if (sticky && primaryBuyRow) {
      // Keep the fixed bar outside any section overflow/sticky stacking context.
      // This is especially important on mobile, where the hero gallery uses overflow:hidden.
      if (sticky.parentElement !== document.body) document.body.appendChild(sticky);

      const syncStickyVisibility = () => {
        const buyRect = primaryBuyRow.getBoundingClientRect();
        const passedPrimaryCta = buyRect.bottom < 0;
        sticky.classList.toggle('is-visible', passedPrimaryCta);
        sticky.setAttribute('aria-hidden', String(!passedPrimaryCta));
      };

      syncStickyVisibility();
      window.addEventListener('scroll', syncStickyVisibility, { passive: true });
      window.addEventListener('resize', syncStickyVisibility, { passive: true });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(syncStickyVisibility, { threshold: [0, 1] });
        observer.observe(primaryBuyRow);
      }
    }

    const shippingDialog = root.querySelector('[data-l4m-shipping-dialog]');
    const countryPicker = shippingDialog?.querySelector('[data-l4m-country-picker]');
    const countryToggle = shippingDialog?.querySelector('[data-l4m-country-toggle]');
    const countrySearch = countryPicker?.querySelector('[data-l4m-country-search]');
    const countryChoices = [...(countryPicker?.querySelectorAll('[data-l4m-country-choice]') || [])];
    const countryEmpty = countryPicker?.querySelector('[data-l4m-country-empty]');
    const countryForm = countryPicker?.querySelector('.l4m-pdp-country-form');
    const countryLoading = countryPicker?.querySelector('[data-l4m-country-loading]');
    const reopenKey = 'l4mShippingDrawerReopen';

    const filterCountries = () => {
      const query = (countrySearch?.value || '').trim().toLocaleLowerCase();
      let visible = 0;
      countryChoices.forEach((choice) => {
        const matches = !query || (choice.dataset.search || '').includes(query);
        choice.hidden = !matches;
        if (matches) visible += 1;
      });
      if (countryEmpty) countryEmpty.hidden = visible !== 0;
    };

    const openShippingDialog = () => {
      if (shippingDialog?.showModal && !shippingDialog.open) shippingDialog.showModal();
    };

    root.querySelector('[data-l4m-shipping-open]')?.addEventListener('click', openShippingDialog);
    shippingDialog?.querySelector('[data-l4m-shipping-close]')?.addEventListener('click', () => shippingDialog.close());
    shippingDialog?.addEventListener('click', (event) => {
      if (event.target === shippingDialog) shippingDialog.close();
    });

    try {
      const reopenPath = sessionStorage.getItem(reopenKey);
      if (reopenPath === window.location.pathname) {
        sessionStorage.removeItem(reopenKey);
        requestAnimationFrame(() => openShippingDialog());
      }
    } catch (_) {}

    countryForm?.addEventListener('submit', () => {
      try { sessionStorage.setItem(reopenKey, window.location.pathname); } catch (_) {}
      if (countryLoading) countryLoading.hidden = false;
      if (countrySearch) countrySearch.disabled = true;
      countryChoices.forEach((choice) => { choice.disabled = true; });
    });

    countrySearch?.addEventListener('input', filterCountries);
    countryToggle?.addEventListener('click', () => {
      const willOpen = countryPicker?.hasAttribute('hidden');
      if (!countryPicker) return;
      countryPicker.toggleAttribute('hidden', !willOpen);
      countryToggle.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) {
        if (countrySearch) countrySearch.value = '';
        filterCountries();
        countrySearch?.focus();
      }
    });
  });

  const initSeoAccordions = (scope = document) => {
    const roots = [];
    if (scope.matches?.('.l4m-pdp-seo-info')) roots.push(scope);
    scope.querySelectorAll?.('.l4m-pdp-seo-info').forEach((root) => roots.push(root));

    roots.forEach((root) => {
      if (root.dataset.l4mSeoAccordionReady === 'true') return;
      root.dataset.l4mSeoAccordionReady = 'true';
      const topics = [...root.querySelectorAll('.l4m-pdp-seo-topic')];
      topics.forEach((topic) => {
        topic.addEventListener('toggle', () => {
          if (!topic.open) return;
          topics.forEach((other) => {
            if (other !== topic && other.open) other.open = false;
          });
        });
      });
    });
  };

  initSeoAccordions();
  document.addEventListener('shopify:section:load', (event) => initSeoAccordions(event.target));

  class L4MReviewShowcase extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.limit = Number(this.dataset.limit || 1);
      this.buttons = [...this.querySelectorAll('[data-filter]')];
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      this.buttons.forEach(button => button.addEventListener('click', () => this.filter(button)));
      this.show('all');
    }
    filter(button) {
      this.buttons.forEach(b => b.classList.toggle('is-active', b === button));
      this.show(button.dataset.filter || 'all');
    }
    show(key) {
      let shown = 0;
      this.cards.forEach(card => {
        const tags = (card.dataset.tags || '').split(/\s+/).filter(Boolean);
        const match = key === 'all' || tags.includes(key);
        const visible = match && shown < this.limit;
        card.hidden = !visible;
        if (visible) shown += 1;
      });
    }
  }
  if (!customElements.get('l4m-review-showcase')) customElements.define('l4m-review-showcase', L4MReviewShowcase);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link || link.getAttribute('href') === '#') return;
    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    if (link.closest('.l4m-pdp')) {
      event.preventDefault();
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
  });
})();
